
import axios from 'axios';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { adminMainUrl } from '../../../../Config';

const ServicesTab = ({ token, user_id, b64id, refresh, OrganisationDetail }) => {
    const [disableSubmit, setDisableSubmit] = useState(false);

    const initialValues = {
        bank: false,
        CFS: false,
        container_provider: false,
        container_terminal_operator: false,
        container_yard: false,
        custom_broker: false,
        fumigation_contractor: false,
        ICD: false,
        packing_depot: false,
        unpacking_depot: false,
        vendor: false
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: values => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                values.customer_id = atob(b64id)
                axios.post(`${adminMainUrl}/api/organization/services-add-update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response.data.msg);
                            refresh();
                            setDisableSubmit(false);
                        } else {
                            toast.error(response.data.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(err => {
                        let msg = "Internal server error!";
                        if (err.response) {
                            if (err.response.data) {
                                if (err.response.data.msg) {
                                    msg = err.response.data.msg
                                }
                            }
                        };
                        toast.error(msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                setDisableSubmit(false);
                toast.error(error.message);
            }
        }
    });


    useEffect(() => {
        if (OrganisationDetail && OrganisationDetail?.EntityService) {
            formik.setFieldValue("bank", OrganisationDetail?.EntityService?.bank);
            formik.setFieldValue("CFS", OrganisationDetail?.EntityService?.CFS);
            formik.setFieldValue("container_provider", OrganisationDetail?.EntityService?.container_provider);
            formik.setFieldValue("container_terminal_operator", OrganisationDetail?.EntityService?.container_terminal_operator);
            formik.setFieldValue("container_yard", OrganisationDetail?.EntityService?.container_yard);
            formik.setFieldValue("custom_broker", OrganisationDetail?.EntityService?.custom_broker);
            formik.setFieldValue("fumigation_contractor", OrganisationDetail?.EntityService?.fumigation_contractor);
            formik.setFieldValue("ICD", OrganisationDetail?.EntityService?.ICD);
            formik.setFieldValue("packing_depot", OrganisationDetail?.EntityService?.packing_depot);
            formik.setFieldValue("unpacking_depot", OrganisationDetail?.EntityService?.unpacking_depot);
            formik.setFieldValue("vendor", OrganisationDetail?.EntityService?.vendor)
        }
    }, [OrganisationDetail])

    return (
        <div className="carf">
            <div className="card-body">
                <form onSubmit={formik.handleSubmit}>
                    <div className='row'>
                        <label htmlFor="" className='form-label'>
                            Services provided by this Organisation
                        </label>
                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="bank"
                                    name="bank"
                                    onChange={(event) => formik.setFieldValue('bank', event.target.checked)}
                                    checked={formik.values.bank} />
                                <label
                                    className="form-check-label"
                                    htmlFor="bank"
                                >
                                    Bank{" "}
                                </label>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="CFS"
                                    name="CFS"
                                    onChange={(event) => formik.setFieldValue('CFS', event.target.checked)}
                                    checked={formik.values.CFS} />
                                <label
                                    className="form-check-label"
                                    htmlFor="CFS"
                                >
                                    CFS (Container Freight Station){" "}
                                </label>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="container_provider"
                                    name="container_provider"
                                    onChange={(event) => formik.setFieldValue('container_provider', event.target.checked)}
                                    checked={formik.values.container_provider} />
                                <label
                                    className="form-check-label"
                                    htmlFor="container_provider"
                                >
                                    Container Provider{" "}
                                </label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="container_terminal_operator"
                                    name="container_terminal_operator"
                                    onChange={(event) => formik.setFieldValue('container_terminal_operator', event.target.checked)}
                                    checked={formik.values.container_terminal_operator} />
                                <label
                                    className="form-check-label"
                                    htmlFor="container_terminal_operator"
                                >
                                    Container Terminal Operator{" "}
                                </label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="container_yard"
                                    name="container_yard"
                                    onChange={(event) => formik.setFieldValue('container_yard', event.target.checked)}
                                    checked={formik.values.container_yard} />
                                <label
                                    className="form-check-label"
                                    htmlFor="container_yard"
                                >
                                    Container Yard{" "}
                                </label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="custom_broker"
                                    name="custom_broker"
                                    onChange={(event) => formik.setFieldValue('custom_broker', event.target.checked)}
                                    checked={formik.values.custom_broker} />
                                <label
                                    className="form-check-label"
                                    htmlFor="custom_broker"
                                >
                                    Custom Broker{" "}
                                </label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="fumigation_contractor"
                                    name="fumigation_contractor"
                                    onChange={(event) => formik.setFieldValue('fumigation_contractor', event.target.checked)}
                                    checked={formik.values.fumigation_contractor} />
                                <label
                                    className="form-check-label"
                                    htmlFor="fumigation_contractor"
                                >
                                    Fumigation Contractor{" "}
                                </label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="ICD"
                                    name="ICD"
                                    onChange={(event) => formik.setFieldValue('ICD', event.target.checked)}
                                    checked={formik.values.ICD} />
                                <label
                                    className="form-check-label"
                                    htmlFor="ICD"
                                >
                                    ICD (Inland Container Depo){" "}
                                </label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="packing_depot"
                                    name="packing_depot"
                                    onChange={(event) => formik.setFieldValue('packing_depot', event.target.checked)}
                                    checked={formik.values.packing_depot} />
                                <label
                                    className="form-check-label"
                                    htmlFor="packing_depot"
                                >
                                    Packing Depot{" "}
                                </label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="unpacking_depot"
                                    name="unpacking_depot"
                                    onChange={(event) => formik.setFieldValue('unpacking_depot', event.target.checked)}
                                    checked={formik.values.unpacking_depot} />
                                <label
                                    className="form-check-label"
                                    htmlFor="unpacking_depot"
                                >
                                    UnPacking Depot{" "}
                                </label>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="form-check ">
                                <input type="checkbox"
                                    className="form-check-input"
                                    id="vendor"
                                    name="vendor"
                                    onChange={(event) => formik.setFieldValue('vendor', event.target.checked)}
                                    checked={formik.values.vendor} />
                                <label
                                    className="form-check-label"
                                    htmlFor="vendor"
                                >
                                    Vendor{" "}
                                </label>
                            </div>
                        </div>
                        <div className="row justify-content-end mt-3 gap-2">
                            <button className="btn btn-primary text-xs w-fit" type="submit" disableSubmit={disableSubmit}>
                                {disableSubmit ? <> <i className="fas fa-spinner fa-spin"></i>Updating...</> : "Update"}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    )
}

export default ServicesTab